import React from 'react';
import { LiveChickenChart } from '../components/LiveChickenChart';
import { LiveChickenTable } from '../components/LiveChickenTable';
import { MarketIQLayout } from '../components/MarketIQLayout';
import { MarketIQNav } from '../components/MarketIQNav';
export function MarketIQChicken() {
  return <MarketIQLayout activeSection="chicken" data-id="element-445" data-mp="p7pwk7jcfh3k">
      <LiveChickenChart data-id="element-446" data-mp="p6exgl0uexis" />
      <MarketIQNav current="chicken" data-id="element-447" data-mp="b8gjhgqfp33t" />
      <LiveChickenTable data-id="element-448" data-mp="b7f7na1lgcl1" />
    </MarketIQLayout>;
}